import { render } from "./CreatureEditor.vue?vue&type=template&id=f1f13f90&lang=true"
import script from "./CreatureEditor.vue?vue&type=script&lang=js"
export * from "./CreatureEditor.vue?vue&type=script&lang=js"

import "./CreatureEditor.vue?vue&type=style&index=0&id=f1f13f90&lang=scss"
script.render = render

export default script